export default __webpack_public_path__ + "static/media/009-architecture.8e750ab6.svg";